import {
    Alert,
    Button,
    Card,
    Col,
    Collapse,
    Divider,
    Empty,
    Form,
    message,
    Modal,
    Row,
    Select,
    Space,
    Spin,
    Tag
} from 'antd';
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import {CustomerDto} from "../../../dto/CustomerDto";
import {useEffect, useRef, useState} from "react";
import LeftSideDetailsCollapse from "../documentanddetailsverification/leftSideCollapse";
import {useHistory} from "react-router-dom";
import adminService from "../../../service/adminService";
import {
    MSG_FAILED_TO_FETCH_CAPTURED_VIDEO_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR,
    MSG_FAILED_TO_FETCH_RELATIONSHIP_MANAGER_LIST_ERROR,
    MSG_SUMMERY_PDF_DOWNLOAD_ERROR
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {
    CheckCircleOutlined,
    CloseOutlined,
    DownloadOutlined,
    ExclamationCircleOutlined,
    EyeOutlined,
    RedoOutlined,
    StopOutlined
} from "@ant-design/icons";
import {
    ADMIN_NEEDED_DOCUMENT_LIST,
    ADMIN_VERIFICATION_TYPE,
    API_RESPONSE_STATUS,
    COMMON_DROPDOWN,
    CUSTOMER_VERIFICATION_STATUS,
    PARAMETER_LIST,
    PREVIEW_DOC_TYPES,
    VIDEO_CODE_CAPTURED_VIDEOS,
} from "../../../util/Constants";
import modal from "antd/es/modal";
import {AdminRequestDto} from "../../../dto/admin/AdminRequestDto";
import TextArea from "antd/es/input/TextArea";
import RightSideDocument from "../documentanddetailsverification/rightSideDocument";
import {ApprovalStatusDto} from "../../../dto/admin/ApprovalStatusDto";
import documentService from '../../../service/documentService';
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import {Error500Page} from "../../common/errorPages/error500Page";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import customerService from "../../../service/customerService";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import PreviewModalComp from "../../common/preview/PreviewModalComp";
import {faVideo} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const {Panel} = Collapse;

interface PropTypes {
    workBasketDto: WorkbasketTableDto | undefined,
    customerDto: CustomerDto | undefined,
    rmCode: number | null,
}

const CustomerVerificationForm = (props: PropTypes) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDocumentCompSpinning, setDocumentCompSpinning] = useState(false);
    const [isCapturedDocumentCompSpinning, setCapturedDocumentCompSpinning] = useState(false);
    const [isCapturedVideoSpinning, setCapturedVideoSpinning] = useState(false);
    const [isDownloading, setDownloading] = useState(false);
    const [documentDtoList, setDocumentDtoList] = useState<[]>();
    const childRef = useRef();
    const [isRemarkModalOpen, setRemarkModalOpen] = useState<boolean>(false);
    const [isVerifyModalOpen, setVerifyModalOpen] = useState<boolean>(false);
    const [isSpinnerLoading, setSpinnerLoading] = useState<boolean>(false);
    const [docURL, setDocURL] = useState<string>();
    const [documentName, setDocumentName] = useState<string>("");
    const [approvalStatusDto, setApprovalStatusDto] = useState<ApprovalStatusDto>();
    const [recordedVideo, setRecordedVideo] = useState<UploadedDocumentDetailDto>();
    const [capturedDocumentList, setCapturedDocumentList] = useState<any[]>([]);
    const history = useHistory();
    let [rejectForm] = Form.useForm();
    let [relationshipManagerForm] = Form.useForm();
    const [relationshipManagerList, setRelationshipManagerList] = useState<DropdownListDto[]>([]);
    const [position, setPosition] = useState({x: 80, y: 94});
    const modalRef = useRef<HTMLDivElement | null>(null);
    const draggingRef = useRef<{ offsetX: number; offsetY: number } | null>(null);

    // Toggle modal visibility

    // Start dragging
    const onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        if ((e.target as HTMLElement).classList.contains('draggable-modal-title-area')) {
            if (modalRef.current) {
                const rect = modalRef.current.getBoundingClientRect();
                draggingRef.current = {offsetX: e.clientX - rect.left, offsetY: e.clientY - rect.top};
            }
        }
    };

    // Drag the modal
    const onMouseMove = (e: MouseEvent) => {
        if (draggingRef.current) {
            const {offsetX, offsetY} = draggingRef.current;
            setPosition({x: e.clientX - offsetX, y: e.clientY - offsetY});
        }
    };

    // Stop dragging
    const onMouseUp = () => {
        draggingRef.current = null;
    };

    useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, []);
    useEffect(() => {
        getCustomerDetails(props.workBasketDto)
        getCapturedList(props.workBasketDto)
    }, [props.workBasketDto])

    const handleCancel = () => {
        setRemarkModalOpen(false);
    };
    const handleVerifyModalCancel = () => {
        setVerifyModalOpen(false);
    };

    const getCustomerDetails = (workbasketDto: any) => {
        setDocumentCompSpinning(true)
        documentService.getUploadDocumentListByType(workbasketDto.customerId, ADMIN_NEEDED_DOCUMENT_LIST).then(res => {
            if (res.data !== null) {
                setDocumentDtoList(res.data.results)

                setDocumentCompSpinning(false)

            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
                setDocumentCompSpinning(false)

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setDocumentCompSpinning(false)

        })
    }
    const getCapturedList = (workbasketDto: any) => {
        setCapturedDocumentCompSpinning(true)
        let adminNeededDocumentList: string[] = ADMIN_NEEDED_DOCUMENT_LIST;
        adminNeededDocumentList.push(VIDEO_CODE_CAPTURED_VIDEOS);

        documentService.getCapturedDocumentListByType(workbasketDto.customerId, adminNeededDocumentList).then(res => {
            if (res.data !== null) {
                let documentDtoList = res.data.results;
                if (null != documentDtoList) {
                    checkAndSetCapturedDocuments(documentDtoList)
                }
                setCapturedDocumentCompSpinning(false)

            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
                setCapturedDocumentCompSpinning(false)

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setCapturedDocumentCompSpinning(false)

        })
    }

    const getCapturedVideo = () => {
        setDownloading(true)

        let uploadDocumentDetailDto = recordedVideo;
        documentService.viewDocument(uploadDocumentDetailDto?.uploadDocumentDetailId as number).then(res => {
            if (res.data !== null) {
                const url = window.URL.createObjectURL(new Blob([res.data], {type: res.headers['content-type']}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', uploadDocumentDetailDto?.originalDocumentName as string);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setDownloading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_CAPTURED_VIDEO_ERROR).then();
                setDownloading(false)

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setDownloading(false)

        })
    }

    const checkAndSetCapturedDocuments = (documents: any) => {
        let capturedDocumentList: any[] = [];
        if (null != documents) {
            documents.forEach((doc: any) => {

                if (doc.documentTypeCode === VIDEO_CODE_CAPTURED_VIDEOS) {
                    let uploadDocumentDetailDto = doc.uploadDocumentDetailDto;
                    if (null == uploadDocumentDetailDto) {
                        setCapturedVideoSpinning(true)
                    } else {
                        setRecordedVideo(uploadDocumentDetailDto);
                    }
                } else {
                    if (null != doc.uploadDocumentDetailDto) {
                        capturedDocumentList.push(doc)
                    }
                }
            })
            setCapturedDocumentList(capturedDocumentList);
        }
    }
    const getBadge = (status: string | undefined) => {
        if (status === "VERIFIED") {
            return <Tag color="success">Verified</Tag>
        } else if (status === "DECLINED") {
            return <Tag color="error">Declined</Tag>
        }else if (status === "ORIGINALLY_SEEN") {
            return <Tag color="success">Originally Seen</Tag>
        }
    }
    const verifyOrReject = (type: CUSTOMER_VERIFICATION_STATUS) => {


        if (undefined !== childRef?.current) {
            let approvalStatusDto: ApprovalStatusDto = (childRef?.current as any)?.approvalData();
            setApprovalStatusDto(approvalStatusDto);

            modal.confirm({
                title: 'Confirm',
                className: 'confirm-dialog-box',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure you want to ${type === CUSTOMER_VERIFICATION_STATUS.REJECTED ?
                    "reject" : type === CUSTOMER_VERIFICATION_STATUS.DECLINED ? "decline" : type === CUSTOMER_VERIFICATION_STATUS.RETRY ? "retry" : "verify"} the job?`,
                okText: 'Yes',
                cancelText: 'No',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    if (type === CUSTOMER_VERIFICATION_STATUS.REJECTED) {
                        setRemarkModalOpen(true)
                    } else {
                        fetchRelationshipManagerList()
                        setVerifyModalOpen(true)
                    }

                },
            });
        } else {
            console.log("child ref null")
        }
    }

    const fetchRelationshipManagerList = () => {
        const dropDownParameterDto: InputDropdownParameterDto =
            {
                dropdownDataSourceId: COMMON_DROPDOWN.RELATIONSHIP_MANAGER_LIST,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            }

        customerService.getCommonDropdown(dropDownParameterDto).then(res => {
            if (res.data !== null) {
                let activeItemList = res.data.results.activeItemList;
                setRelationshipManagerList(activeItemList)
                let rmCode = null;
                if (null != props.rmCode) {
                    const containsValue = activeItemList.some((item: any) => {
                        return item.value == props.rmCode
                    });
                    if (containsValue) {
                        rmCode = props.rmCode;
                    }
                } else {
                    rmCode = props.rmCode;
                }
                relationshipManagerForm.setFieldsValue({relationshipManager: rmCode})
            } else {
                message.error(MSG_FAILED_TO_FETCH_RELATIONSHIP_MANAGER_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const submitRequest = (type: CUSTOMER_VERIFICATION_STATUS, adminRequestDto: AdminRequestDto) => {
        handleCancel()
        setSpinnerLoading(true)
        adminService.verifyCustomer(adminRequestDto).then((res) => {
            if (res.data !== null) {
                message.success(`Task ${type === CUSTOMER_VERIFICATION_STATUS.REJECTED ? "rejected" : "verified"} successfully`).then(() => {
                    history.push('/workflow/admin/customerVerification')
                })
            } else {
                message.error(`Task ${type === CUSTOMER_VERIFICATION_STATUS.REJECTED ? "rejection" : "verification"} failure`)
                setSpinnerLoading(false)
            }
        }).catch(reason => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason)
        })
    }

    const submitReject = (value: { rejectReason: string | undefined, internalRemark: string | undefined }) => {
        let adminRequestDto = {} as AdminRequestDto;
        adminRequestDto.adminWorkType = ADMIN_VERIFICATION_TYPE.CUSTOMER_VERIFICATION
        adminRequestDto.workId = undefined != props.workBasketDto ? props.workBasketDto?.workId : 0
        adminRequestDto.customerVerificationStatus = CUSTOMER_VERIFICATION_STATUS.REJECTED
        adminRequestDto.rejectReason = value.rejectReason
        adminRequestDto.internalRemark = value.internalRemark
        adminRequestDto.ceoApproval = getStatusByBoolean(approvalStatusDto?.ceoApproval)
        adminRequestDto.complianceOfficerApproval = getStatusByBoolean(approvalStatusDto?.coApproval)
        submitRequest(CUSTOMER_VERIFICATION_STATUS.REJECTED, adminRequestDto)
    }
    const submitVerify = (value: { relationshipManager: number }) => {
        let adminRequestDto = {} as AdminRequestDto;
        adminRequestDto.adminWorkType = ADMIN_VERIFICATION_TYPE.CUSTOMER_VERIFICATION
        adminRequestDto.workId = undefined != props.workBasketDto ? props.workBasketDto?.workId : 0
        adminRequestDto.customerVerificationStatus = CUSTOMER_VERIFICATION_STATUS.VERIFIED
        adminRequestDto.rejectReason = ""
        adminRequestDto.ceoApproval = getStatusByBoolean(approvalStatusDto?.ceoApproval)
        adminRequestDto.complianceOfficerApproval = getStatusByBoolean(approvalStatusDto?.coApproval)
        adminRequestDto.relationshipManager = value.relationshipManager
        submitRequest(CUSTOMER_VERIFICATION_STATUS.VERIFIED, adminRequestDto)
    }

    const getStatusByBoolean = (approval: boolean | undefined) => {
        if (undefined !== approval) {
            return approval ? "Yes" : "No";
        }
    }

    const openModal = (document: UploadedDocumentDetailDto) => {
        setCapturedDocumentCompSpinning(true)
        documentService.viewOriginalDocument(document.uploadDocumentDetailId.toString()).then(res => {
            setCapturedDocumentCompSpinning(false)
            if (res.data !== null) {
                // setIsModalOpen(true)
                setDocumentName(document.documentTypeName);
                setDocURL(res.data.results);
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setCapturedDocumentCompSpinning(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };

    const downloadSummery = () => {

        if (documentDtoList) {
            let filteredDocument: any = documentDtoList.filter((documentDto: any) => documentDto.documentTypeCode === "CSR");

            let filteredDocumentElement = filteredDocument[0];
            if (undefined != filteredDocumentElement) {
                documentService.viewOriginalDocument(filteredDocumentElement.uploadDocumentDetailDto.uploadDocumentDetailId).then(res => {
                    if (res.data !== null) {
                        let a = document.createElement('a');
                        a.href = res.data.results;
                        a.download = "Summary Document";
                        a.click();

                    } else {
                        message.error(MSG_SUMMERY_PDF_DOWNLOAD_ERROR).then();
                    }
                }).catch(reason => {
                    ErrorHandler.handleError(reason);
                })
            } else {
                message.error("Unable to download Summary PDF!")
            }
        } else {
            console.log("document list is null")
        }

    }


    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {
        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };
    const closeModal = () => {
        setDocURL("");
        // setIsModalOpen(false)
    };

    const download = () => {
        let a = document.createElement('a');
        a.href = docURL;
        a.download = undefined != documentName ? documentName : "Document";
        a.click();
    }


    return (
        <>
            {isSpinnerLoading ?
                <div className="loader-container">
                    <Spin size="large" tip="Loading"></Spin>
                </div>
                :
                <div>
                    {/*{getBadge(props.workBasketDto?.detailVerificationStatus ?? "")}*/}
                    {/*<Collapse className={'custom_collapse margin_bottom_20'} defaultActiveKey={['1']}>*/}
                    {/*    <Panel header="Details and Documents" key="1" className={'custom_collapse margin_bottom_20'}>*/}
                    <Row gutter={[32, 32]}>
                        <Col xl={12} lg={12} sm={24}>

                            <Card title="Details Entered by the Customer"
                                  className='document_and_details_verification_card' size='small'>

                                {props.customerDto && <LeftSideDetailsCollapse dataDto={props.customerDto}/>}
                            </Card>
                        </Col>
                        <Col xl={12} lg={12} sm={24}>
                            <Card title="Documents Uploaded by the Customer "
                                  className='document_and_details_verification_card'
                                  size='small'>

                                {isDocumentCompSpinning ?
                                    <div className=" custom_loader_styles">
                                        <Spin size="large" tip="Loading"></Spin>
                                    </div>
                                    :
                                    documentDtoList ?
                                        <Collapse className={'custom_collapse'} defaultActiveKey={['1']}>
                                            <Panel header={
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    flexDirection: "row"
                                                }}>
                                                    <span>Document Verification</span>
                                                    {getBadge(props.workBasketDto?.detailVerificationStatus ?? "")}

                                                </div>
                                            } key="1">
                                                <RightSideDocument isCompareView={false}
                                                                   workBasketDto={props.workBasketDto}
                                                                   ref={childRef} dataDto={{
                                                    customerMstDto: props.customerDto,
                                                    documentDtoList: documentDtoList
                                                }}/>
                                            </Panel>
                                            <Panel header={
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    flexDirection: "row"
                                                }}>
                                                    <span>Video Verification</span>
                                                    {getBadge(props.workBasketDto?.videoVerificationStatus ?? "")}

                                                </div>
                                            } key="2">
                                                <Spin spinning={isCapturedDocumentCompSpinning}>
                                                    <Row>
                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                            <div>
                                                                <Divider orientationMargin="0" orientation="left"
                                                                         className='upload-document-divider'>Captured
                                                                    Images</Divider>
                                                                {capturedDocumentList && capturedDocumentList.length > 0 ?
                                                                    <Row gutter={16}>
                                                                        {capturedDocumentList.map((document: any) => {


                                                                            return (
                                                                                document.uploadDocumentDetailDto !== null ?
                                                                                    <Col xxl={12} xl={12} lg={12}
                                                                                         style={{marginBottom: 8}}>
                                                                                        <div
                                                                                            className='utility_bill img-nic'>
                                                                                            <div
                                                                                                className='utulity_bill_icon_div'>
                                                                                                <div
                                                                                                    className="img_div">
                                                                                                    <img
                                                                                                        src={document.uploadDocumentDetailDto?.thumbB64}
                                                                                                        alt=""/>
                                                                                                </div>
                                                                                                <div
                                                                                                    className='name_div'>
                                                                                                    <h5>{document.uploadDocumentDetailDto?.documentTypeName}</h5>
                                                                                                </div>
                                                                                            </div>
                                                                                            <Button
                                                                                                className='doc-view-btn'
                                                                                                onClick={() => openModal(document.uploadDocumentDetailDto)}><EyeOutlined/></Button>
                                                                                        </div>
                                                                                    </Col> : ''
                                                                            )
                                                                        })}

                                                                    </Row>
                                                                    :
                                                                    <Row gutter={16}>
                                                                        <Col xxl={24} xl={24} lg={24}>
                                                                            <Empty
                                                                                image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                                                        </Col>
                                                                    </Row>
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                            <div>
                                                                <Divider orientationMargin="0" orientation="left"
                                                                         className='upload-document-divider'>Video
                                                                    Recording</Divider>

                                                                {!isCapturedVideoSpinning ?
                                                                    <Row gutter={[16, 16]}>
                                                                        <Col span={24}>
                                                                            <Spin spinning={isDownloading}
                                                                                  tip="Downloading...">
                                                                                <div className="video-download-div">
                                                                                    <div
                                                                                        className="video-file-icon-div">
                                                                                        <FontAwesomeIcon
                                                                                            className={'video-icon'}
                                                                                            icon={faVideo}/>
                                                                                    </div>
                                                                                    <div className="video-download-btn">
                                                                                        <Button size={'large'}
                                                                                                type="link"
                                                                                                icon={
                                                                                                    <DownloadOutlined/>}
                                                                                                onClick={getCapturedVideo}>
                                                                                            Download
                                                                                        </Button>
                                                                                    </div>
                                                                                </div>

                                                                            </Spin>
                                                                        </Col>
                                                                    </Row>

                                                                    :
                                                                    <Row gutter={16}>
                                                                        <Col xxl={24} xl={24} lg={24}>
                                                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                                                   description={
                                                                                       <>
                                                                                           <p>
                                                                                               If video verification is
                                                                                               recorded, it will be
                                                                                               uploaded
                                                                                               here.
                                                                                           </p>
                                                                                           <Alert description="Processing time for compositions is typically about half the length
                                                    of the original recording. During periods of high demand, it might
                                                    take a few hours for compositions to be completed." type="info"
                                                                                                  showIcon/>

                                                                                       </>
                                                                                   }/>
                                                                        </Col>
                                                                    </Row>
                                                                }
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Spin>
                                            </Panel>
                                        </Collapse>
                                        :
                                        <Error500Page/>
                                }
                            </Card>

                        </Col>

                    </Row>
                    {API_RESPONSE_STATUS.FAILED === props?.workBasketDto?.apiResponseStatus ?
                        <Row gutter={[32, 32]} className={'margin_top_20'}>
                            <Col xl={24} lg={24} sm={24}>
                                <Alert type="error" message="Error Log" showIcon
                                       description={props?.workBasketDto?.apiFailedReason}/>
                            </Col>
                        </Row>
                        :
                        <></>
                    }
                    {/*</Panel>*/}
                    {/*</Collapse>*/}


                    {/*<Spin spinning={isCapturedDocumentCompSpinning}>*/}


                    <Row className='margin_top_20 doc-approve-reject-btns'>
                        <Col sm={24} md={24} lg={24} xl={24} className='text_align_end'>
                            {documentDtoList && <Space>
                                <Button className={'download-btn'}
                                        onClick={downloadSummery}><DownloadOutlined/> Download PDF</Button>
                                {API_RESPONSE_STATUS.FAILED !== props?.workBasketDto?.apiResponseStatus ?
                                    <>
                                        <Button type='primary' danger
                                                onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.REJECTED)}>
                                            <StopOutlined/> Reject</Button>
                                        <Button type={'primary'}
                                                onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.VERIFIED)}>
                                            <CheckCircleOutlined/> Verify</Button>
                                    </>
                                    :
                                    <Button type={'primary'}
                                            onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.RETRY)}>
                                        <RedoOutlined/> Retry</Button>
                                }
                            </Space>}
                        </Col>
                    </Row>
                    {/*</Spin>*/}


                    {/*{docURL &&*/}
                    {/*    <CommonModalComp modalProp={{isModalOpen: isModalOpen, title: documentName, docURL: docURL}}/>}*/}

                    {/*{docURL && <Modal*/}
                    {/*    className={checkDocumentContentType(docURL) == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : ""}*/}
                    {/*    open={isModalOpen}*/}
                    {/*    title={documentName}*/}
                    {/*    onCancel={closeModal}*/}
                    {/*    destroyOnClose={true}*/}
                    {/*    width={checkDocumentContentType(docURL) == PREVIEW_DOC_TYPES.PDF ? 800 : 600}*/}
                    {/*    footer={[*/}
                    {/*        <Button type="primary" icon={<DownloadOutlined/>}*/}
                    {/*                style={{background: '#FF7400', height: 40}} onClick={download}>*/}
                    {/*            Download*/}
                    {/*        </Button>]}*/}
                    {/*>*/}
                    {/*    <PreviewModalComp docURL={docURL} divHeight={'70vh'}/>*/}
                    {/*</Modal>}*/}

                    {docURL &&
                        <div
                            ref={modalRef}
                            className="draggable-modal"
                            style={{
                                position: 'fixed',
                                top: position.y,
                                left: position.x,
                                zIndex: 1000,
                            }}
                            onMouseDown={onMouseDown}
                        >
                            <div className="draggable-modal-title-area">
                                <span className={'modal-title'}>{documentName}</span>
                                <Button icon={<CloseOutlined/>} size={'small'} onClick={closeModal}/>
                            </div>
                            <div className="modal-body-area">
                                <PreviewModalComp docURL={docURL} divHeight={'70vh'}/>
                            </div>
                            <div className="modal-footer-area">
                                <Button type="primary" icon={<DownloadOutlined/>}
                                        style={{background: '#FF7400', height: 40}} onClick={download}>
                                    Download
                                </Button>
                            </div>
                        </div>
                    }

                    {/*verification reject reason modal*/}
                    <Modal destroyOnClose={true}
                           maskClosable={false}
                           title="Reject Reason / Internal Remark"
                           open={isRemarkModalOpen}
                           footer={[]}
                           onCancel={handleCancel}
                    >

                        <Form
                            className='form-input attachments-upload-form'
                            layout={"vertical"}
                            form={rejectForm}
                            preserve={false}
                            onFinish={submitReject}
                        >
                            <Form.Item
                                name={"rejectReason"}
                                label={<b>Reject Reason</b>}
                                rules={[{
                                    required: true,
                                    message: 'Please enter reject reason'
                                }]}>
                                <TextArea showCount placeholder="Please enter reject reason" maxLength={255}
                                          bordered={true}/>
                            </Form.Item>
                            <Form.Item
                                name={"internalRemark"}
                                label={<b>Internal Remark</b>}>
                                <TextArea showCount placeholder="Please enter internal remark" maxLength={255}
                                          bordered={true}/>
                            </Form.Item>
                            <Form.Item>
                                <Space style={{float: 'right'}}>
                                    <Button htmlType="submit" type="success"
                                            style={{
                                                background: "#FF7400",
                                                color: "white",
                                                marginTop: 12
                                            }}>Submit</Button>
                                </Space>
                            </Form.Item>


                        </Form>
                    </Modal>

                    {/*verification modal*/}
                    <Modal destroyOnClose={true}
                           maskClosable={false}
                           title="Relationship Manager Allocation"
                           open={isVerifyModalOpen}
                           footer={[]}
                           onCancel={handleVerifyModalCancel}
                    >

                        <Form
                            className='form-input attachments-upload-form'
                            layout={"vertical"}
                            form={relationshipManagerForm}
                            preserve={false}
                            onFinish={submitVerify}
                        >
                            <Form.Item
                                name={"relationshipManager"}
                                label={<b>Relationship Manager</b>}
                                rules={[{
                                    required: true,
                                    message: 'Please enter relationship manager'
                                }]}>

                                <Select placeholder={"Select relationship manager"}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input: any, option: {
                                            label: any;
                                        }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                        getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                        options={relationshipManagerList}
                                        disabled
                                />
                            </Form.Item>
                            <Form.Item>
                                <Space style={{float: 'right'}}>
                                    <Button htmlType="submit" type="success"
                                            style={{
                                                background: "#FF7400",
                                                color: "white",
                                                marginTop: 12
                                            }}>Submit</Button>
                                </Space>
                            </Form.Item>


                        </Form>
                    </Modal>
                </div>}
        </>
    )
};


export default CustomerVerificationForm;
